module.exports = __webpack_public_path__ + "static/media/UnlockProduct.88bb3f92.svg";